import { Observable } from '../Observable';
import { createOperatorSubscriber } from './OperatorSubscriber';
export function skipWhile(predicate) {
    return function (source) {
        return new Observable(function (subscriber) {
            var taking = false;
            var index = 0;
            source.subscribe(createOperatorSubscriber(subscriber, function (value) { return (taking || (taking = !predicate(value, index++))) && subscriber.next(value); }));
        });
    };
}
//# sourceMappingURL=skipWhile.js.map